import BaseComponent from 'foundation/base-component';

export default class CountriesComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.onCountriesChange = this.onCountriesChange.bind(this);
        this.init();
    }

    init() {
        if (this.refs.countries && this.refs.counties) {
            this.getCountriesList();
            this.addListener(this.refs.countries, 'change', this.onCountriesChange);
        }
    }

    getCountriesList() {
        const countriesSelect = this.refs.countries.querySelector('select');
        if (this.refs.county) {
            this.countries = [];
            this.refs.county.forEach((county) => {
                if (this.countries.indexOf(county.getAttribute('data-country')) === -1) {
                    this.countries.push(county.getAttribute('data-country'));
                }
            });

            if (this.countries.indexOf(countriesSelect.value) !== -1) {
                this.filterCounties(countriesSelect.value);
                this.refs.counties.classList.add('is-visible');
            }
        }
    }

    onCountriesChange = (event) => {
        if (this.countries.indexOf(event.target.value) !== -1) {
            this.filterCounties(event.target.value);
            this.refs.counties.classList.add('is-visible');
            this.refs.counties.querySelector('select').value = '-1';
        } else {
            this.refs.counties.classList.remove('is-visible');
        }
    };

    filterCounties(country) {
        const countyContainer = document.getElementById('Address_County');
        countyContainer.innerHTML = '<option class="form-select__option" disabled="disabled" selected="selected" value="-1">County</option>';

        this.refs.county.forEach((county) => {
            if (county.getAttribute('data-country') === country) {
                countyContainer.appendChild(county);
            }
        });
    }
}
